const KEYS = {
  ADMIN_NOTIFICATIONS: 'admin-notifications',
};

export default { ...KEYS };
